import { DevicePoint } from "../Analytics";
import { ResponsivePie } from "@nivo/pie";
import { theme } from "../../../theme";
import { TooltipPie } from "./Tooltips";
export const SessionsPerDeviceType = ({
  data,
  colors,
}: {
  data?: Array<DevicePoint>;
  colors: Array<string>;
}) => {
  if (!data) return null;
  const total = data.reduce((prev, curr) => prev + curr.count, 0);
  const processedData = data
    .map((d) => ({
      id: d.device,
      value: d.count,
      percentage: ((d.count * 100) / total).toFixed(0),
    }))
    .filter((d) => d.percentage !== "0");

  return (
    <div style={{ height: "350px" }} className="sessions-per-device">
      <h2>Views per device type</h2>
      <ResponsivePie
        data={processedData}
        innerRadius={0.25}
        sortByValue={true}
        colors={(r) =>
          colors[
            processedData.findIndex((d) => d.id === r.id) % processedData.length
          ] || theme.primary
        }
        animate={true}
        fit={true}
        enableArcLabels={false}
        enableArcLinkLabels={false}
        activeOuterRadiusOffset={8}
        arcLinkLabel={"id"}
        legends={[
          {
            data: processedData.map((d) => ({
              id: d.id,
              label: `${d.id}: ${d.value} (${d.percentage}%)`,
              color:
                colors[
                  processedData.findIndex((e) => e.id === d.id) %
                    processedData.length
                ] || theme.primary,
            })),
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 55,
            translateY: 30,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 25,
            itemTextColor: "#999",
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#000",
                },
              },
            ],
          },
        ]}
        margin={{
          left: 50,
          right: 110,
          top: 10,
          bottom: 100,
        }}
        tooltip={TooltipPie}
      />
    </div>
  );
};
